import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwControlType, DwCustomContextBase, DwCustomContextDefinition,
    DwExpressionCompareType, DwOrmDataService, DwQueryMdAttribute, DwSecurityTopics } from '@devwareapps/devware-cap';
import { defer } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppMetaData } from '../../../../meta-data/app-meta-data.service';
import { FitnessReferenceDataService } from '../../services/fitness-reference-data.service';

export interface CurrentChallengeContextData {
    ChallengeDefinitionId: number;
    ChallengeName: string;
}

/** The configured active streak, independent of the participant's selected season. */
@DwCustomContextDefinition({ keyName: 'current-challenge-context', display: 'Current Challenge', isGlobal: true })
@Injectable()
export class CurrentChallengeContextService extends DwCustomContextBase {
    constructor(private reference: FitnessReferenceDataService) { super(); }

    setupContextDefinition(contextDef: DwContextDefinition): void {
        // Reference data owns caching and identity isolation. Avoid a second CAP
        // context cache retaining an old challenge after reference refresh.
        contextDef.noCache = true;
        contextDef.defaultAttributeName = 'ChallengeDefinitionId';
        contextDef.defaultCompareType = DwExpressionCompareType.equal;
        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED, 'Fitness.ReferenceData.Refresh',
            DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.ChallengeDefinition.ItemDetail.itemName)];
        contextDef.loadContext = () => defer(() => this.reference.getActiveChallenge()).pipe(take(1), map(challenge => {
            if (!challenge || !Number.isSafeInteger(challenge.ChallengeDefinitionId) || challenge.ChallengeDefinitionId <= 0
                || challenge.IsCurrent !== true) {
                throw new Error('A current challenge must be configured before applying this filter.');
            }
            const value: CurrentChallengeContextData = {
                ChallengeDefinitionId: challenge.ChallengeDefinitionId, ChallengeName: challenge.Name || '',
            };
            return value;
        }));
        const attributes: DwQueryMdAttribute[] = [];
        this.addProperty(attributes, 'ChallengeDefinitionId', 'Challenge ID', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'ChallengeName', 'Challenge Name', DwAttributeType.Text, DwControlType.Textbox);
        contextDef.attributes = attributes;
    }
}
